import * as sentry from '@sentry/react';
import mixpanel from 'mixpanel-browser';
import 'moment/locale/da';
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/nl';
import 'moment/locale/pt';
import 'moment/locale/sv';

export const initializePlugins = () => {
	if (!import.meta.env.DEV) {
		sentry.init({
			dsn: import.meta.env.VITE_SENTRY_DSN,
			integrations: [sentry.browserTracingIntegration()],
			tracePropagationTargets: ['api.ontreams.com'],
			// We recommend adjusting this value in production, or using tracesSampler
			// for finer control
			tracesSampleRate: 0.1,
		});
	}

	const mixpanelToken = import.meta.env.VITE_MIXPANEL_API_TOKEN;
	if (mixpanelToken) {
		mixpanel.init(mixpanelToken, {
			api_host: 'https://api-eu.mixpanel.com',
			cross_subdomain_cookie: true,
		});
	}
};
